import {
  ALTRU_INFO,
  MY_INFO,
  STUDIO_A_RESOURCE_ID,
  STUDIO_B_RESOURCE_ID,
  PRODUCERS_USER_GROUP_ID,
  PRODUCER_IDS,
  ACTIVITY_IDS
} from "./constants";

// Npm packages
const request = require("request-promise");

//Returns current date and time in ISO format
const getIsoDateAndTime = () => {
  const date = new Date();

  //const timeZoneOffset = date.getTimezoneOffset(); //for UTC
  const timeZoneOffset = 300; //for eastern time

  date.setMinutes(date.getMinutes() - timeZoneOffset);

  return date.toISOString();
};

//Returns the date in 00-00-0000 format
const getIsoDate = () => {
  const isoDate = getIsoDateAndTime();
  return isoDate.slice(0, 10);
};

const { company_account_id, api_key } = ALTRU_INFO;

const baseBody = {
  lang: "eng",
  company_account_id: company_account_id,
  apiKey: api_key
};

/**
 * General format for Scoro API requests
 */

const apiCall = async (url, params) => {
  const body = params ? { ...baseBody, ...params } : baseBody;
  const options = { url: url, body: JSON.stringify(body) };
  const response = await request.post(options);

  //console.log(JSON.parse(response));
  return JSON.parse(response).data;
};

const heroku_url = "https://polar-tundra-12678.herokuapp.com";
const prefix = `${heroku_url}/https://${company_account_id}.scoro.com/api/v2`;
/**
 * Specific API routes
 */

const ACTIVITIES = {
  list: async () => {
    const url = `${prefix}/activities/list`;
    return await apiCall(url);
  }
};

export const CONTACTS = {
  list: async (email, page) => {
    const url = `${prefix}/contacts/list`;

    const params = {};

    if (email)
      params.filter = {
        means_of_contact: {
          email: email
        }
      };

    if (page) params.page = page;

    return await apiCall(url, params);
  },

  view: async (contact_id) => {
    const url = `${prefix}/contacts/view/${contact_id}`;
    return await apiCall(url);
  }
};

export const CALENDAR_EVENTS = {
  list: async (from, to) => {
    const url = `${prefix}/calendar/list`;
    const params = {
      filter: {
        start_datetime: {
          from_date: from,
          to_date: to
        }
      }
    };
    return await apiCall(url, params);
  },

  view: async (event_id) => {
    const url = `${prefix}/calendar/view/${event_id}`;
    return await apiCall(url);
  },

  delete: async (event_id) => {
    const url = `${prefix}/calendar/delete/${event_id}`;
    return await apiCall(url);
  },

  create: async (
    event_name,
    start_datetime,
    end_datetime,
    studio_id,
    user_id,
    contact_id,
    invoice_id,
    activity_type
  ) => {
    const url = `${prefix}/calendar/modify`;

    const params = {
      request: {
        event_name: event_name,
        start_datetime: start_datetime,
        end_datetime: end_datetime,
        resources: studio_id ? [{ resource_id: studio_id }] : null,
        cal_user: user_id ? [{ id: user_id }] : null,
        person_id: contact_id,
        invoice_id: invoice_id,
        activity_id: ACTIVITY_IDS[activity_type],
        is_confirmed: true
      }
    };
    const res = await apiCall(url, params);

    return res.event_id;
  },

  checkAvailability: async () => {
    const url = `${prefix}/calendar/check`;
    const params = {
      request: {
        duration: "01:00",
        start_dates: ["2021-09-13 10:00:00"]
      }
    };
    return await apiCall(url, params);
  }
};

export const INVOICES = {
  list: async () => {
    const url = `${prefix}/invoices/list`;
    const params = {
      detailed_response: true,
      filter: {
        date: {
          from_date: "2021-09-26",
          to_date: "2021-09-28"
        }
      }
    };
    const res = await apiCall(url, params);

    //console.log(res.filter((el) => el.date === "2021-09-27"));
  },

  view: async (id) => {
    const url = `${prefix}/invoices/view/${id}`;

    return await apiCall(url);
  },

  delete: async (id) => {
    const url = `${prefix}/invoices/delete/${id}`;
    return await apiCall(url);
  },

  create: async (contact_id, user_id, duration, hourlyRate) => {
    const url = `${prefix}/invoices/modify`;

    const params = {
      request: {
        company_id: contact_id,
        paid_sum: duration * hourlyRate,
        sum: duration * hourlyRate,
        owner_email: "john@altrucreative.com",
        owner_id: user_id,
        date: getIsoDate(),
        deadline: getIsoDate(),
        status: "paid",
        lines: [
          {
            product_id: 15, //Recording
            comment: `${duration} hour(s) with ${PRODUCER_IDS[user_id]}`,
            sum: duration * hourlyRate,
            doer_id: user_id,
            price: hourlyRate,
            amount: duration
          }
        ]
      }
    };

    const res = await apiCall(url, params);

    return { invoice_id: res.id, invoice_line_id: res.lines[0].id };
  }
};

export const TIME_ENTRIES = {
  create: async (event_id, user_id, contact_id, activity_id, invoice_line_id) => {
    const url = `${prefix}/timeEntries/modify`;

    const params = {
      return_data: true,
      request: {
        event_id: event_id,
        invoice_id: 1373,
        invoice_line_id: 1562
      }
    };
    return await apiCall(url, params);
  },

  list: async (to, from) => {
    const url = `${prefix}/timeEntries/list`;
    const params = {
      filter: {
        modified_date: {
          from_date: "2021-10-04",
          to_date: "2021-09-05"
        }
      }
    };
    return await apiCall(url, params);
  },

  view: async (id) => {
    const url = `${prefix}/timeEntries/view/${id}`;

    return await apiCall(url);
  }
};

export const USERS = {
  list: async () => {
    const url = `${prefix}/users/list`;

    const res = await apiCall(url);

    return res.filter(
      (el) =>
        el.user_groups_ids && el.user_groups_ids.includes(PRODUCERS_USER_GROUP_ID)
    );
  }
};

//viewContact(1063);
//viewInvoice(1326);
//createInvoice(1063, 1, 1.5, 40);
//listInvoices();
//viewInvoice(1331);
//listCalendarEvents("2021-09-28", "2021-09-28");
